export default __webpack_public_path__ + "static/media/curry.648e205b.png";